import React from 'react';
import PropTypes from 'prop-types';
import Span from '@deliveroo/consumer-component-library/components/Span';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import LoadingIndicator from '@deliveroo/consumer-component-library/components/LoadingIndicator';
import classnames from 'classnames';
import { getTargetURL } from '../../utils/home/factories';
import HomeSuggestionRow from '../HomeSuggestionRow';
import HomeBanner from '../HomeBanner';
import { UITextLine } from '../HomeFeedUILines';
import { SUPPORTED_BLOCKS } from '../../utils/home/constants';
import styles from './styles.scss';

class HomeSuggestionBox extends React.Component {
  componentDidMount() {
    if (this.props.trackViewedSearchDropDown) {
      this.props.trackViewedSearchDropDown(this.props.data);
    }

    if (this.props.isModalResults) {
      document.addEventListener('touchmove', this.scrollStart, false);
    }
  }

  componentWillUnmount() {
    if (this.props.isModalResults) {
      document.removeEventListener('touchmove', this.scrollStart, false);
    }
  }

  scrollStart = () => {
    if (this.props.handleOnTouchMove) {
      this.props.handleOnTouchMove();
    }
  };

  buildUILine = (uiLines) => {
    if (!uiLines) return null;
    return (
      <ul>
        {uiLines.filter((uiLine) => uiLine.typeName === 'UITextLine').map((uiLine) => (
          <React.Fragment key={uiLine.key}>
            <UITextLine uiSpans={uiLine.uiSpans} truncate={false} />
          </React.Fragment>
        ))}
      </ul>
    );
  };

  render() {
    const {
      data,
      onClickResult,
      isModalResults,
      selectedResult,
      isLoading,
      handleOnMouseOver,
      keyboardSelectActive,
    } = this.props;

    const suggestionBoxClasses = classnames(styles.suggestionBox, {
      [styles.suggestionBoxModal]: isModalResults,
      [styles.loaderWrapper]: isLoading,
    });

    if (isLoading) {
      return (
        <div className={suggestionBoxClasses}>
          <LoadingIndicator color="teal" size={48} />
        </div>
      );
    }

    let resultIndex = -1;

    return (
      <div className={suggestionBoxClasses}>
        {data.map((result) => {
          if (result.typeName === SUPPORTED_BLOCKS.BANNER) {
            return (
              <HomeBanner
                key={result.key}
                heading={result.header}
                caption={result.caption}
                buttonCaption={result.buttonCaption}
                type={result.theme}
                images={result.images}
                isSearchResults
              />
            );
          }
          return (
            <div
              className={styles.section}
              key={result.key}
              onMouseOver={handleOnMouseOver}
              onFocus={handleOnMouseOver}
            >
              <Heading level={4} spacing={isModalResults ? 'small 0' : 'small'}>
                {result.header}
              </Heading>
              {result.options.map((option) => {
                resultIndex++;
                const url = getTargetURL(option.target);
                const isViewAllLink = option.key === 'show-all-results';
                return (
                  <HomeSuggestionRow
                    image={option.image}
                    key={option.key}
                    onClick={(event) => {
                      onClickResult({ event, target: option.target });
                    }}
                    url={url}
                    isHighlighted={selectedResult === resultIndex && keyboardSelectActive}
                    keyboardSelectActive={keyboardSelectActive}
                    resultIndex={resultIndex}
                  >
                    {isViewAllLink ? (
                      <Span color="teal">{option.label}</Span>
                    ) : (
                      this.buildUILine(option.uiLines)
                    )}
                    {Boolean(option.count) &&
                      isViewAllLink && (
                        <Span color={isViewAllLink ? 'teal' : 'light-grey'} spacing="0 0 0 small">
                          ({option.count})
                        </Span>
                      )}
                  </HomeSuggestionRow>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

HomeSuggestionBox.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      key: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          count: PropTypes.number,
          highlights: PropTypes.arrayOf(
            PropTypes.shape({
              begin: PropTypes.number,
              end: PropTypes.number,
            }),
          ),
          image: PropTypes.shape({
            type: PropTypes.string,
            default: PropTypes.string,
          }),
          label: PropTypes.string,
          target: PropTypes.shape({
            typeName: PropTypes.string,
            restaurant: PropTypes.shape({
              name: PropTypes.string,
              links: PropTypes.shape({
                self: PropTypes.shape({
                  href: PropTypes.string,
                }),
              }),
            }),
          }),
        }),
      ),
    }),
  ).isRequired,
  onClickResult: PropTypes.func.isRequired,
  isModalResults: PropTypes.bool,
  trackViewedSearchDropDown: PropTypes.func,
  selectedResult: PropTypes.number,
  isLoading: PropTypes.bool,
  handleOnTouchMove: PropTypes.func,
  handleOnMouseOver: PropTypes.func,
  keyboardSelectActive: PropTypes.bool,
};

HomeSuggestionBox.defaultProps = {
  keyboardSelectActive: false,
  isModalResults: false,
  trackViewedSearchDropDown: undefined,
  selectedResult: undefined,
  isLoading: false,
  handleOnTouchMove: undefined,
  handleOnMouseOver: undefined,
};

export default HomeSuggestionBox;
